<template>
  <div class="hello">
    <div class="slides-container">
      <div
        class="slide"
        :style="{
          position: 'absolute',
          top: 0,
          backgroundImage: `linear-gradient(-90deg, #00000000 0%, #7a7a7aa5 60%), url(${require('@/assets/b02.webp')})`
        }"
      >
        <div class="t">
          <h1 class="title">
            Guincho 24 Horas<br />
            <span class="title">Atendimento Rápido, Seguro e Pelo Melhor Preço!</span>
          </h1>
          <p>
            Precisa de guincho agora? Oferecemos suporte imediato em todos os bairros com total profissionalismo e transparência. Chame agora e resolvemos para você!
          </p>

          <div class="banner-contato">
            <a target="_blank" href="tel:19995504994" class="btn b2">
              <img class="icon32" width="24" height="24" :src="require('@/assets/phone-32.svg')" alt="ligar" />
              LIGUE AGORA MESMO
            </a>
          </div>
          <div class="banner-contato">
            <a
              target="_blank"
              href="https://api.whatsapp.com/send?phone=5519995504994&text=Olá%20Fabios%20Guincho,%20Gostaria%20de%20solicitar%20um%20orçamento."
              class="btn b1"
            >
              <img class="icon32" width="24" height="24" :src="require('@/assets/whatsapp-32.svg')" alt="whatsapp" />
              CHAME NO WHATSAPP
            </a>
          </div>
        </div>

        <div id="circulo-banner" class="banner-container">
          <svg class="rotate" version="1.1" xmlns="http://www.w3.org/2000/svg" width="300" height="300" viewBox="0 0 300 300">
            <defs>
              <path id="circulo-rotativo-banner" d="M150,150 m-60,0 a60,60 0 1,1 120,0 a60,60 0 1,1 -120,0" />
            </defs>
            <g>
              <use xlink:href="#circulo-rotativo-banner" fill="none"></use>
              <text fill="#fff">
                <textPath xlink:href="#circulo-rotativo-banner" class="rotating-text">
                  Pagamento facilitado no cartão <tspan fill="#00CF4B">•</tspan>
                </textPath>
              </text>
            </g>
          </svg>
        </div>
      </div>
    </div>

    <section style="max-width: 90vw; margin: 0 auto">
      <h2 class="title">Precisando de guincho? Estamos prontos para ajudar!</h2>
      <p>
        No Fabio's Guincho, oferecemos serviços de guincho e reboque 24 horas com rapidez, segurança e eficiência. Seja uma pane mecânica, pneu furado, falta de combustível ou qualquer outra emergência, nossa equipe está sempre disponível para atender você.
      </p>
    </section>

    <section style="max-width: 90vw; margin: 0 auto">
      <h2 class="title">Conheça alguns Trabalhos já realizados</h2>
      <div style="text-align: left; margin: 20px 0;">
        <div>✅ Guincho leve e pesado</div>
        <div>✅ Reboque para carros, motos e utilitários</div>
        <div>✅ Pane seca (falta de combustível)</div>
        <div>✅ Remoção de veículos em acidentes</div>
        <div>✅ Transporte para oficinas e concessionárias</div>
      </div>
    </section>

    <section style="background: #7A7A7A17;">
      <ul class="g4">
        <li v-for="i in 8" :key="i">
          <img :src="require(`@/assets/i0${i}.webp`)" :alt="`guincho imagem ${i}`" loading="lazy" />
        </li>
      </ul>
    </section>

    <section style="max-width: 90vw; margin: 0 auto; display: flex; justify-content: center; align-items: center;">
      <a target="_blank" href="tel:19995504994" class="btn b2">
        <img class="icon32" width="24" height="24" :src="require('@/assets/phone-32.svg')" alt="ligar" />
        PEÇA SEU GUINCHO AGORA
      </a>
    </section>

    <section>
      <a
        target="_blank"
        href="https://api.whatsapp.com/send?phone=5519995504994&text=Olá%20Fabios%20Guincho,%20Gostaria%20de%20solicitar%20um%20orçamento."
        class="whatsapp-button"
      >
        <img :src="require('@/assets/whatsapp-32.svg')" alt="whatsapp" width="32" height="32" />
      </a>

      <footer class="footer-section">
        <div class="row">
          <div>
            <h3>Sobre Nós</h3>
            <p>
              A <strong>Fabio's Guincho</strong> é referência em remoção e transporte de veículos, oferecendo atendimento rápido e seguro 24 horas por dia. Com uma equipe experiente e uma frota moderna, garantimos suporte confiável em momentos de urgência.
              Atendemos toda a Grande São Paulo e Região Metropolitana, sempre prezando pela qualidade e eficiência.
            </p>
          </div>

          <div>
            <h3>Informações do Negócio</h3>
            <div class="contact-info">
              <a
                target="_blank"
                href="https://api.whatsapp.com/send?phone=5519995504994&text=Olá%20Fabios%20Guincho,%20Gostaria%20de%20solicitar%20um%20orçamento."
                class="icon-text"
              >
                <span>(19) 9 9550-4994</span>
              </a>
              <a target="_blank" href="tel:19995504994" class="icon-text">
                <span>(19) 9 9550-4994</span>
              </a>
              <a target="_blank" href="mailto:contato@fabiosguincho.com.br" class="icon-text">
                <span>contato@fabiosguincho.com.br</span>
              </a>
            </div>
          </div>

          <div>
            <h3>ACEITAMOS CARTÕES</h3>
            <div style="display: flex; flex-direction: column; align-items: center;">
              <img :src="require('@/assets/cartoes.webp')" alt="cartões" width="300" style="max-width: 90%;" />
              <img :src="require('@/assets/ssl.webp')" alt="ssl" width="300" style="max-width: 90%;" />
            </div>
          </div>
        </div>

        <div class="copyright-area">
          <p style="text-align: center;">&copy; {{ year }} - Todos os direitos reservados</p>
        </div>
      </footer>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Kanit:wght@300;400;700&display=swap');

.banner-container {
  overflow: hidden;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height:150px;
  max-width: 150px;
  top: 0;
  right:0px;
}

.rotate {
  animation: rotate 10s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
#circulo-banner::before {
    content: '';
    background-image: url("@/assets/rotacao-cartao.webp");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 50px;
    height: 50px;
    position: absolute;
    right: 0;
    left: 0;
    margin: 0 auto;
}
text {
  font-size: 19px;
  font-weight: bold;
  text-transform: uppercase;
}

* {
  overflow: hidden;
  text-decoration: none;
}
/* .btn {
    background: #ff0000;
    color: #fff!important;
    padding: 20px 30px !important;
    border-radius: 99px;
    max-width: 20vw !important;
    min-width: 20vw !important;
    margin: 50px;
    animation: pulse 4s infinite, pisca 5s infinite;
    box-shadow: 0 0 21px -6px #ff000071;
} */
@keyframes pulse {
    0% {
        transform: scaleX(1)
    }

    50% {
        transform: scale3d(1.05,1.05,1.05)
    }

    to {
        transform: scaleX(1)
    }
}
@keyframes pisca {
    70% {
        box-shadow: 0 0 0 25px transparent
    }

    to {
        box-shadow: 0 0 0 0 transparent
    }
}
.slides-container {
  border-top: 15px solid red;
  position: relative;
  max-width: 100vw;
  min-width: 100vw;
  left: 0!important;
  height: 600px;
  overflow: hidden
}
body{
  background: red;
}
.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.5s ease-in-out;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.slide[style*="display: block;"] {
  opacity: 1;
}

.g4 {
    padding: 0 !important;
    margin: 0 auto !important;
    display: grid;
    max-width: 90% !important;
    @media only screen and (max-width: 600px) {
        max-width:100%!important;
        grid-template-columns: repeat(2,50%)
    }
    grid-template-columns: repeat(4, 25%);
    -moz-column-gap: 5px;
    column-gap: 5px;
    row-gap: 2.5px;
  img {
    max-width: 100% !important;
    min-width: 100% !important;
    width: auto;
    height: auto;
  }
}

.t {
  position: absolute;
  top: 5%;
  left: 6%;
  z-index: 10;
  max-width: 50vw !important;
  min-height: 100% !important;

  * {
    color: #fff !important;
  }
  .title{
    @media only screen and (max-width: 600px) {
      font-size: 48px;
    }
  }
  @media only screen and (max-width: 600px) {
    left: 5%;
    max-width: 90vw !important;
    min-height: 100% !important;
  }
}

.font-hover {
  color: #ffffff !important;
  font-weight: 700;
  font-size: 2.5rem;
  text-transform: uppercase;
}

.banner-contato {
  display: flex;
  flex-direction: column;
  /* Ajuste conforme necessário */
  gap: 16px;

  /* Espaçamento entre os alvos de toque */
  * {
    color: #fff !important
  }
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 20px 30px;
  margin:20px auto;
  border: none;
  border-radius: 36px;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 600;
  max-width: 25vw !important;

  @media only screen and (max-width: 600px) {
    max-width: 50vw !important;
    min-width: 50vw !important;
    font-size: 0.7rem;
  }

  cursor: pointer;
}

.b1 {
  background: #00CF4B;
  color: white;
  animation: pisca 1.5s infinite;
  box-shadow: 0px 0px 21px -6px #00CF4B;
}

.b2 {
  background-color: darken(#ff0000, 10%);
  box-shadow: 0px 0px 21px -6px #ff0000;
  animation: pisca 1.5s infinite;
  color: white;
}

.icon32 {
  margin-right: 8px;
}

.btn:hover {
  background-color: #000
}

.btn.b2:hover {
  background-color: #000
}
.servicos{
    display: flex;
    flex-wrap: wrap;
    li {
    min-width: 45%;
    @media only screen and (max-width: 600px) {
        min-width: 100%;
    }
}
}
.footer-content{
    padding: 0 5px;
    p{
      text-align: left!important;
    }
}
.icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 18px;
    margin-right: 5px;
    color: #d5d5d5;
    font-size: 10px;
    text-align: center;
    background-color: #f3f3f6;
    vertical-align: middle;
    border-radius: 50%;
}
.row {
    display: flex;
    position: relative;
    width: 92vw;
    margin: 0 auto!important;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 6px;
    div{
       img{
       min-width: 80%!important;
       }
        width: calc((100%/3) - 4px);
        @media only screen and (max-width: 600px) {
            width: 95%;
    }
    }
}
*{
    overflow: hidden!important;
}
h3 {
    @media only screen and (max-width: 600px) {
            font-size: 28px;
    }
    font-family: "Teko", Sans-serif;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 58px;
    color:#000
}
.footer-section {
    min-width: 100vw!important;
    max-width: 100vw!important;
    background: #7A7A7A17;
    color: #000
}

.contact-info{
    min-width: 55%;
    margin: 0 auto!important;
    .icon-text {
    display: flex;
    margin-bottom: 10px;
    color:#000!important;
}
}

.copyright-area {
    padding: 15px 0;
    color: #000;
    text-align: center;
    div{
        margin: 0 auto!important;
    }
}
.copyright{
    display: flex;
    justify-content: center;
}
@media (max-width: 767px) {
    .footer-menu {
        margin-top: 30px;
    }
}
.whatsapp-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #00CF4B;
        width: 48px;
        height: 48px;
        padding: 20px;
        font-size: 16px;
        border-radius: 100%;
        text-decoration: none;
        animation: pulse 4s infinite, pisca 1.5s infinite;
        box-shadow: 0px 0px 21px -6px #25D366;
        // animation: pisca 1.5s infinite;
        transition: background-color 0.3s ease;
        position: fixed;
        bottom: 2vh;
        right: 5vw;
        @media only screen and (max-width: 600px) {
        }
        z-index: 1000;
    }

    .whatsapp-button:hover {
        background-color: #2aee72;
    }
</style>
